import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

export interface UserMaterialFolderCreateResponse {
  folder: Folder;
};

export interface Folder {
  id: number;
  folder_uuid: string;
  parent_folder_id: number;
  user_id: number;
  folder_name: string;
  create_time: number;
  update_time: number;
  deleted_time?: string;
};

class RenameFolderData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;
}

class UserMaterialFolderCreateData {
  @Required("Folder cannot be empty")
  @ValidateNested(RenameFolderData)
  folder: RenameFolderData;
}

const transformAndValidateData = (
  response: UserMaterialFolderCreateResponse
): UserMaterialFolderCreateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserMaterialFolderCreateData);
  } catch (error) {
    console.error("User material folder create data validation failed:", error.message);
    throw error;
  }
};

/** 素材目录创建 */
export const userMaterialFolderCreate = async ({
  parentFolderId,
  folderName
}: {
  parentFolderId: number,
  folderName: string
}) => {
  const res = await apiV2.post<UserMaterialFolderCreateResponse>('/user_material/create_folder', {
    parent_folder_id: parentFolderId,
    folder_name: folderName,
  });
  const data = transformAndValidateData(res.data);
  return data;
}